import { render } from "./App.vue?vue&type=template&id=3bdcd41b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./css/bootstrap.css?vue&type=style&index=0&lang=css&external"
import "./css/main.css?vue&type=style&index=1&lang=css&external"
import "./css/main_shared.css?vue&type=style&index=2&lang=css&external"
import "./css/responsive.css?vue&type=style&index=3&lang=css&external"
import "./css/customSelect.css?vue&type=style&index=4&lang=css&external"
import "./css/digita11yaccessible.css?vue&type=style&index=5&lang=css&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__